import type {
  AddressChangeCommandData,
  AddressLink,
} from '@festina/legalentity-general-types/legalentity'
import { notEmpty, typeUtils } from '@festina-life/core'
import { FormikFieldArray } from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

import { useLegalentityLatestEntityVersion } from '../../hooks/useLegalentityLatestEntityVersion'
import { useService } from '../../lenteHooks'
import { cleanupAddressVersion } from '../../utility/addressVersionUtils'
import { newDefaultAddressLink } from '../../utility/newDefaultAddressLink'
import type { CommandDataFormProps } from '../commandActions/CommandDataFormAndSimulation'
import { LifeForm } from '../forms/LifeForm'
import { AddressLinkFields } from './AddressLinkFields'

const validateKey = typeUtils.createValidator<AddressChangeCommandData>()

export function AddressChangeForm(
  props: CommandDataFormProps<AddressChangeCommandData>,
) {
  const translate = useTranslate()
  const cleanupInformationSource = useService(
    'logic.legalEntity.cleanupInformationSource',
  )

  const entityVersion = useLegalentityLatestEntityVersion()

  const addressLinks = (
    entityVersion?.addressVersions?.filter(notEmpty) ?? []
  ).map(
    (address) =>
      ({
        _type: 'AddressLink',
        addressType: address.addressType,
        address: cleanupAddressVersion(address),
      }) satisfies AddressLink,
  )

  return (
    <LifeForm
      initialValues={cleanupInformationSource({
        _type: 'AddressChangeCommandData',
        addressLinks,
      } satisfies AddressChangeCommandData)}
      frame={{ _type: 'AnyVFrame' }}
      {...props}
    >
      <FormikFieldArray
        name={validateKey('addressLinks')}
        label={translate('addressLink.field.addressLinks')}
        elementLabel={translate('addressLink.field.addressLink')}
        elementInitializer={newDefaultAddressLink}
        ChildElement={AddressLinkFields}
      />
    </LifeForm>
  )
}
